export default __webpack_public_path__ + "static/media/Group514-Yono@2x.78cbea28.png";